export const TASK_TO_PRESET: Record<string, { documentType: string; stage?: 'loading' | 'unloading' | 'other'; fileType?: 'file' | 'photo' }> = {
  LOADING_PHOTO: {
    documentType: 'LOADING_PHOTO',
    stage: 'loading',
    fileType: 'photo',
  },
  UPLOAD_LOADING_PHOTO: {
    documentType: 'LOADING_PHOTO',
    stage: 'loading',
    fileType: 'photo',
  },
  UPLOAD_LOADING_DOCS: {
    documentType: 'LOADING_TN',
    stage: 'loading',
    fileType: 'file',
  },
  UNLOADING_PHOTO: {
    documentType: 'UNLOADING_PHOTO',
    stage: 'unloading',
    fileType: 'photo',
  },
  LOADING_DOCUMENTS_UPLOAD: {
    documentType: 'LOADING_TN',
    stage: 'loading',
    fileType: 'file',
  },
  UNLOADING_DOCUMENTS_UPLOAD: {
    documentType: 'UNLOADING_DOC',
    stage: 'unloading',
    fileType: 'file',
  },
  NO_DOCS_UNLOADING: {
    documentType: 'UNLOADING_DOC',
    stage: 'unloading',
    fileType: 'file',
  },
  UPLOAD_UNLOADING_DOCS: {
    documentType: 'UNLOADING_DOC',
    stage: 'unloading',
    fileType: 'file',
  },
  UPD_UPLOAD: {
    documentType: 'UPD_ACT',
    stage: 'other',
    fileType: 'file',
  },
  UPLOAD_UPD: {
    documentType: 'UPD_ACT',
    stage: 'other',
    fileType: 'file',
  },
  CARRIER_INVOICE_MISSING: {
    documentType: 'CARRIER_INVOICE',
  },
  INVOICE_EXPECTED: {
    documentType: 'CARRIER_INVOICE',
  },
  UPLOAD_TN_ORIGINAL: {
    documentType: 'ORIGINAL_TN',
    stage: 'other',
    fileType: 'file',
  },
  TN_ORIGINAL_MISSING: {
    documentType: 'ORIGINAL_TN',
    stage: 'other',
    fileType: 'file',
  },
};
